/**
 * 안내 후 webview를 종료하는 모달.
 *
 * 확인 시 onPrevious 브릿지로 앱 네이티브 스택을 1단계 pop — webview를 빠져나가
 * 유저가 앱에서 다시 진입하게 한다. 데이터 조회 실패(진입·상세·수량변경)·
 * 중복 신청 등 "이 화면에 더 머무를 수 없는" 상황의 통보용.
 */

import { useBridge } from '@onl-web/shared/bridge'

import { DialogModal } from '@/components/ui/DialogModal'

interface ExitDialogProps {
  title: string
  description?: string
}

export function ExitDialog({ title, description }: ExitDialogProps) {
  const { callHandler } = useBridge()

  const handleConfirm = () => {
    void callHandler('onPrevious', { pages: 1 })
  }

  return (
    <DialogModal
      isOpen
      onClose={handleConfirm}
      title={title}
      description={description}
      confirmLabel='확인'
      onConfirm={handleConfirm}
    />
  )
}
